module.exports = __webpack_public_path__ + "static/media/THE-CALF.021679f6.jpg";